import React from 'react';

import Container from '@hero/ui-kit/layout/Container';
import Section from '@hero/ui-kit/layout/Section';
import Table from '../../../../components/Table';
import { PastSevenDaysEvent } from '../../types';
import { useOrganizationMemberDetailsContext } from '../context/OrganizationMemberDetailsContext';
import MemberDetailsWrapper from '../MemberDetailsWrapper';
import DeviceEvent from './DeviceEvent';
import DeviceLogLineItem from './DeviceLogLineItem';
import MembershipLogLineItem from './MembershipLogLineItem';
import { usePreparedDeviceStatusLogs } from './usePreparedDeviceStatusLogs';
import { groupMembershipLogs, usePreparedMembershipLogs } from './usePreparedMembershipLogs';

const HistoryLogModule: React.FC = () => {
    const { currentDevice, memberDetails } = useOrganizationMemberDetailsContext();

    const preparedDeviceEvents: PastSevenDaysEvent[] = React.useMemo(() => {
        if (memberDetails?.device_log?.past_seven_days) {
            return memberDetails.device_log.past_seven_days.filter(
                (item) => item.event_count && item.event_type
            );
        }

        return [];
    }, [memberDetails]);

    const preparedMembershipLogs = usePreparedMembershipLogs(memberDetails);
    const membershipLogGroups = React.useMemo(
        () => groupMembershipLogs(preparedMembershipLogs),
        [preparedMembershipLogs]
    );
    const preparedDeviceStatusLogs = usePreparedDeviceStatusLogs(currentDevice);

    return (
        <Section noDefaultPadding marginVertical="large">
            <Container gridTemplateColumns={'1fr 1fr'} gridColumnGap="large">
                <div>
                    <h5 style={{ fontSize: '2.4rem' }}>Membership log</h5>

                    <Section noDefaultPadding marginVertical="regular">
                        {!preparedMembershipLogs.length ? (
                            <div>Hero user is not activated yet</div>
                        ) : (
                            <Table size="compact" zebra>
                                {membershipLogGroups.map((group, index) => (
                                    <MembershipLogLineItem key={`${index}`} group={group} />
                                ))}
                            </Table>
                        )}
                    </Section>
                </div>

                <div>
                    {preparedDeviceEvents.length ? (
                        <>
                            <h5 style={{ fontSize: '2.4rem' }}>Device events</h5>

                            <Section noDefaultPadding marginVertical="regular" marginBottom="large">
                                <div className="vertical-rhythm-compact">
                                    {preparedDeviceEvents.map((item) => (
                                        <DeviceEvent key={item.event_type} {...item} />
                                    ))}
                                </div>
                            </Section>
                        </>
                    ) : null}

                    <h5 style={{ fontSize: '2.4rem' }}>Device status log</h5>

                    <Section noDefaultPadding marginVertical="regular">
                        <Table size="compact" zebra>
                            {preparedDeviceStatusLogs.map((item) => (
                                <DeviceLogLineItem key={item.timestamp} item={item} />
                            ))}
                        </Table>
                    </Section>
                </div>
            </Container>
        </Section>
    );
};

const HistoryLogModuleWrapper: React.FC = () => {
    return (
        <MemberDetailsWrapper>
            <Section noDefaultPadding paddingHorizontal="regular">
                <HistoryLogModule />
            </Section>
        </MemberDetailsWrapper>
    );
};
export default HistoryLogModuleWrapper;
